import axios from 'axios';
import api from './axiosInstance';
import { ExtendedRegistrationRequest } from '../types/user';

export interface AuthResponse {
  success: boolean;
  accessToken?: string;
  refreshToken?: string;
  message?: string;
}

export interface LegalEntityApplicationRequest {
  entityType: string;
  companyName: string;
  inn: string;
  kpp?: string;
  companyPhone?: string;
  legalAddress: string;
  contactPersonName: string;
  contactPersonPhone: string;
  contactPersonEmail: string;
}

export interface LegalEntityApplicationResponse {
  success: boolean;
  message: string;
  applicationId?: number;
}

export const authApi = {
  register: async (username: string): Promise<AuthResponse> => {
    try {
      const response = await api.post<AuthResponse>('/identity/register', null, {
        params: { username }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return {
          success: false,
          message: error.response?.data?.message || 'Ошибка регистрации'
        };
      }
      return {
        success: false,
        message: 'Произошла ошибка при регистрации'
      };
    }
  },

  registerExtended: async (data: ExtendedRegistrationRequest): Promise<AuthResponse> => {
    try {
      const response = await api.post<AuthResponse>('/identity/register-extended', data);
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return {
          success: false,
          message: error.response?.data?.message || 'Ошибка регистрации'
        };
      }
      return {
        success: false,
        message: 'Произошла ошибка при регистрации'
      };
    }
  },

  createLegalEntityApplication: async (data: LegalEntityApplicationRequest): Promise<LegalEntityApplicationResponse> => {
    try {
      const response = await api.post<LegalEntityApplicationResponse>('/LegalEntityApplication', data);
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return {
          success: false,
          message: error.response?.data?.message || 'Ошибка создания заявки'
        };
      }
      return {
        success: false,
        message: 'Произошла ошибка при создании заявки'
      };
    }
  },

  login: async (username: string, password: string): Promise<AuthResponse> => {
    try {
      const anonymousId = localStorage.getItem('anonymousId');
      const response = await api.post<AuthResponse>('/identity/login', null, {
        params: { username, password, anonymousId }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return {
          success: false,
          message: error.response?.data?.message || 'Ошибка входа'
        };
      }
      return {
        success: false,
        message: 'Произошла ошибка при входе'
      };
    }
  },

  refreshToken: async (refreshToken: string): Promise<AuthResponse> => {
    try {
      const response = await api.post<AuthResponse>('/identity/refreshToken', null, {
        params: { token: refreshToken }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return {
          success: false,
          message: error.response?.data?.message || 'Ошибка обновления токена'
        };
      }
      return {
        success: false,
        message: 'Произошла ошибка при обновлении токена'
      };
    }
  },

  restorePassword: async (username: string): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/identity/restore', null, {
      params: { username }
    });
    return response.data;
  }
}; 